import React, { useContext } from 'react';
import { withRouter, Redirect } from 'react-router-dom';

import { ComponentContext } from '../../context/componentContext';
import { AuthContext } from '../../context/authContext';

import Header from '../Header';
import Sidebar from '../Sidebar';

const Layout = ({ children, location }) => {
  const { menuOpen } = useContext(ComponentContext);
  const { isAuthenticated } = useContext(AuthContext);

  const HeaderComp = () => {
    if (isAuthenticated()) {
      return <Header />;
    }
    return <Redirect to="/" />;
  };

  return (
    <>
      <div className="font-sans text-base">
        {isAuthenticated() &&
        location.pathname !== '/notfound' &&
        location.pathname !== '/start-farm' ? (
          <HeaderComp />
        ) : (
          ''
        )}

        <div className="flex">
          {isAuthenticated() &&
          location.pathname !== '/notfound' &&
          location.pathname !== '/start-farm' ? (
            <div className={menuOpen === false ? 'w-14' : ' md:w-40 z-40'}>
              <Sidebar />
            </div>
          ) : (
            ''
          )}
          <div className="antialiased overflow-hidden min-w-md md:min-w-full">
            <div className="md:flex-grow">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Layout);
